export default {
    get SET_LANGUAGE () {
        return 'setSelectedLanguage';
    },
    get SET_SCREEN_SOURCE () {
        return 'SET_SCREEN_SOURCE';
    },
    get APPLICATION_ERROR () {
        return 'APPLICATION_ERROR';
    },
    get SET_IFRAME_PARAMS () {
        return 'SET_IFRAME_PARAMS';
    },
    get SET_VIEWPORT () {
        return 'SET_VIEWPORT';
    },
    get SET_IS_IN_EDIT_MODE () {
        return 'SET_IS_IN_EDIT_MODE';
    },
    get SET_EDIT_CONFIGURATION () {
        return 'SET_EDIT_CONFIGURATION';
    },
    get SET_INVESTMENT_OBJECTIVE () {
        return 'SET_INVESTMENT_OBJECTIVE';
    },
    get SET_PREVIOUS_INVESTMENT_STRATEGY_SELECTED () {
        return 'SET_PREVIOUS_INVESTMENT_STRATEGY_SELECTED';
    },
    get RESET_PREVIOUS_INVESTMENT_STRATEGY_SELECTED () {
        return 'RESET_PREVIOUS_INVESTMENT_STRATEGY_SELECTED';
    },
    get SET_INVESTMENT_STRATEGY_SELECTED () {
        return 'SET_INVESTMENT_STRATEGY_SELECTED';
    },
    get SET_INVESTMENT_STRATEGY_RECOMMENDED_BASED_ON_INVESTMENT_HORIZON () {
        return 'SET_INVESTMENT_STRATEGY_RECOMMENDED_BASED_ON_INVESTMENT_HORIZON';
    },
    get SET_INVESTMENT_STRATEGY_RECOMMENDED_BASED_ON_RISK_TOLERANCE () {
        return 'SET_INVESTMENT_STRATEGY_RECOMMENDED_BASED_ON_RISK_TOLERANCE';
    },
    get SET_INVESTMENT_THEME () {
        return 'SET_INVESTMENT_THEME';
    },
    get SET_REGIONAL_FOCUS () {
        return 'SET_REGIONAL_FOCUS';
    },
    get SET_OTHER_INVESTMENTS () {
        return 'SET_OTHER_INVESTMENTS';
    },
    get SET_INVESTMENT_AMOUNT () {
        return 'SET_INVESTMENT_AMOUNT';
    },
    get SET_INVESTMENT_HORIZON () {
        return 'SET_INVESTMENT_HORIZON';
    },
    get SET_DETAILS_FILTER_TYPE () {
        return 'SET_DETAILS_FILTER_TYPE';
    },
    get SET_DETAILS_SUB_FILTER_TYPE () {
        return 'SET_DETAILS_SUB_FILTER_TYPE';
    },
    get SET_MODEL_PORTFOLIO_DETAILS () {
        return 'SET_MODEL_PORTFOLIO_DETAILS';
    },
    get SET_MODEL_PORTFOLIO_POSITIONS () {
        return 'SET_MODEL_PORTFOLIO_POSITIONS';
    },
    get SET_INVESTMENT_QR_CODE_VALUE () {
        return 'SET_INVESTMENT_QR_CODE_VALUE';
    },
    get SET_RISK_TOLERANCE_BLOCK_1_SELECTED_ANSWER () {
        return 'SET_RISK_TOLERANCE_BLOCK_1_SELECTED_ANSWER';
    },
    get SET_RISK_TOLERANCE_BLOCK_2_SELECTED_ANSWER () {
        return 'SET_RISK_TOLERANCE_BLOCK_2_SELECTED_ANSWER';
    },
    get SET_RISK_TOLERANCE_BLOCK_3_SELECTED_ANSWER () {
        return 'SET_RISK_TOLERANCE_BLOCK_3_SELECTED_ANSWER';
    },
    get SET_LAST_OPEN_SECTION () {
        return 'SET_LAST_OPEN_SECTION';
    },
    get SET_EMAIL_ADDRESS () {
        return 'SET_EMAIL_ADDRESS';
    },
    get ADD_OPEN_SECTION () {
        return 'ADD_OPEN_SECTION';
    },
    get REMOVE_OPEN_SECTION () {
        return 'REMOVE_OPEN_SECTION';
    },
    get SET_INVESTMENT_DIAGRAM_RESPONSE () {
        return 'SET_INVESTMENT_DIAGRAM_RESPONSE';
    },
    get SET_SETTINGS () {
        return 'SET_SETTINGS';
    },
    get SET_USER_IS_CUSTOMER () {
        return 'SET_USER_IS_CUSTOMER';
    },
};
